// extracted by mini-css-extract-plugin
module.exports = {"pageAlert":"pagealert_pageAlert__VT53G"};